import React, { useEffect, useMemo, useState } from "react"
import PropTypes, { func } from "prop-types"
import { Link, useNavigate } from "react-router-dom"
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../components/Common/TableContainer"
import Moment from "moment"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import DeleteModal from "../../components/Common/DeleteModal"
import { EnumRoleTypes } from "helpers/enum_helper"

import {
  getUsers as onGetUsers,
  deleteUser as onDeleteUser,
  addUserHappening as onAddUserHappening,
  getUserDetail as onGetUserDetail,
  updateImpersonateUser as onUpdateImpersonateUser,
} from "store/actions"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

import {
  Badge,
  Button,
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
} from "reactstrap"
import { getUserImagePath } from "helpers/imageService"
import Spinners from "components/Common/Spinner"
// import { ToastContainer } from "react-toastify"
import { isEmpty } from "lodash"
import ImpersonateModal from "./modal/ImpersonateModal"
import i18n from "./../../i18n"
import ProfilePicture from "components/Common/ProfilePicture"
import { EnumObjectTypes } from "helpers/enum_helper"
import { useUserDetail } from "hooks"
import { useRole } from "hooks/useRole"

function User() {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { users, loading } = useSelector(state => state.user)
  const { userprofile } = useUserDetail()
  const [roleLabel, setRoleLabel] = useState("User")

  const [isLoading, setLoading] = useState(loading)
  const [deleteModal, setDeleteModal] = useState(false)
  const [user, setUser] = useState(null)
  const [impersonateModal, setImpersonateModal] = useState(false)
  const { basicSetting } = useSelector(state => state.Layout)
  //meta title
  document.title =
    "Users | " + (basicSetting?.SiteName || process.env.REACT_APP_NAME)
  useEffect(() => {
    dispatch(onGetUsers())
  }, [dispatch])

  const handleAddClick = () => {
    navigate("/user/new")
  }

  const onClickDelete = arg => {
    setUser(arg)
    setDeleteModal(true)
  }

  const onClickImpersonate = arg => {
    setUser(arg)
    setImpersonateModal(true)
  }

  const handleDelete = () => {
    if (user && user.UserID) {
      dispatch(onDeleteUser(user.UserID))
      setDeleteModal(false)
    }
  }

  const handleImpersonateUser = () => {
    if (user && user.UserID) {
      dispatch(onUpdateImpersonateUser(user.UserID))
      setImpersonateModal(false)
    }
  }

  const handleValidDate = date => {
    const date1 = Moment(new Date(date)).format("DD MMM Y")
    return date1
  }

  const UserStatus = ({ status }) => {
    switch (status) {
      case true:
        return <Badge className="bg-success"> Active </Badge>
      case false:
        return <Badge className="bg-danger"> Inactive </Badge>
      default:
        return ""
    }
  }

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "Name",
        Cell: cellProps => {
          const { RowID, Name, RoleTypeID, RoleType, GranteeOrgName } =
            cellProps.row.original

          return (
            <ProfilePicture
              ObjectTypeID={EnumObjectTypes.User}
              RowID={RowID}
              Title={Name}
              SubTitle={RoleType}
              ToUrl={`/user/${RowID}`}
            />
          )
        },
      },
      {
        Header: "Reference#",
        accessor: row => (row.UserID ? `Citizen ${row.UserID}` : ""),
        Cell: cellProps => {
          return cellProps.value ? `${cellProps.value}` : ""
        },
      },
      {
        Header: "Email",
        accessor: "Email",
        Cell: cellProps => {
          return cellProps.value ? cellProps.value : ""
        },
      },
      {
        Header: "Created By",
        accessor: "CreatedBy",
        Cell: cellProps => {
          return (
            <>
              <span className="font-size-14 mb-1">
                {cellProps.row.original.CreatedByName}
              </span>
              <p className="text-muted mb-0">
                {handleValidDate(cellProps.row.original.CreatedDate)}
              </p>
            </>
          )
        },
      },
      {
        Header: "Status",
        accessor: "IsActive",
        Cell: cellProps => {
          return <UserStatus status={cellProps.value} />
        },
      },
      {
        Header: "Action",
        Cell: cellProps => {
          const { RoleTypeID } = cellProps.row.original
          return (
            <div className="d-flex gap-3">
              {RoleTypeID === parseInt(EnumRoleTypes.Administrator) && (
                <Link
                  to="#"
                  className="text-primary d-none"
                  onClick={() => {
                    onClickImpersonate(cellProps.row.original)
                  }}
                  style={{
                    display:
                      userprofile.Impersonate ||
                      cellProps.row.original.UserID == userprofile.UserID
                        ? "none"
                        : "inline-block",
                  }}
                >
                  <i
                    className="bx bx-log-in-circle font-size-18"
                    id="impersonatetooltip"
                  />
                  <UncontrolledTooltip
                    placement="top"
                    target="impersonatetooltip"
                  >
                    Impersonate
                  </UncontrolledTooltip>
                </Link>
              )}
              <Link
                to={"/user/" + cellProps.row.original.RowID}
                className="text-secondary d-none"
              >
                <i className="bx bx-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Edit
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  onClickDelete(cellProps.row.original)
                }}
              >
                <i className="bx bx-trash font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Delete
                </UncontrolledTooltip>
              </Link>
            </div>
          )
        },
      },
    ],
    []
  )
  return (
    <React.Fragment>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDelete}
          onCloseClick={() => setDeleteModal(false)}
        />
      )}
      {impersonateModal && (
        <ImpersonateModal
          show={impersonateModal}
          text="You want to impersonate this user?"
          onSubmitClick={handleImpersonateUser}
          onCloseClick={() => setImpersonateModal(false)}
        />
      )}
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title={roleLabel} breadcrumbItem={`${roleLabel} List`} />
          {isLoading ? (
            <Spinners setLoading={setLoading} />
          ) : (
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <TableContainer
                      columns={columns}
                      data={users}
                      isGlobalFilter={true}
                      isAddOption={true}
                      addOptionText={`Add ${roleLabel}`}
                      handleAddClick={handleAddClick}
                      customPageSize={10}
                      isPagination={true}
                      filterable={false}
                      iscustomPageSizeOptions={true}
                      tableClass="align-middle table-nowrap table-check"
                      theadClass="table-light"
                      pagination="pagination pagination-rounded mb-0 ms-auto"
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </div>
      </div>
      {/* <ToastContainer /> */}
    </React.Fragment>
  )
}
User.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default User
